export const mouseMoving = (listener,element,deepX = 1,deepY = 1)=> {
    let mousemoveTimeout = null;
    let moving = false;
    const M = 2;

    function imageMove(e) {
        const x = e.clientX;
        const y = e.clientY;
        const w = window.innerWidth;
        const h = window.innerHeight;
        const deltaX = -(x/w) * 100 * M + (100 * M/2);
        const deltaY = -(y/h) * 100 * M + (100 * M/2);

        if (element) {
            if(window.matchMedia("(min-width: 1024px)").matches){
                element.style.transform = 'translate(' + deltaX * deepX + 'px, ' + deltaY / deepY + 'px)';

                window.clearTimeout(mousemoveTimeout);
                mousemoveTimeout = null;
            } else {
                element.style.transform = 'translate(0px)';
            }
        }

    }

    listener?.addEventListener('mousemove',(e)=> {
        if (mousemoveTimeout == null) {
            mousemoveTimeout = window.setTimeout(function(){
                moving = false;
                imageMove(e);

            }, 10);
        }
    })

}
